export default __webpack_public_path__ + "static/media/portal-manual-icon.d8538081.svg";